var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FranchiseReportTable',{attrs:{"headers":_vm.headers,"load-report-url":"facebook-report","user-search":_vm.userSearch,"human-readable-report-name":"Facebook Report","excel-report-name":"facebook_report"}})}
var staticRenderFns = []

export { render, staticRenderFns }